
import './styles.css';
import { useHistory } from "react-router-dom";

function Settings() {

    const history = useHistory();

    return (
        <div className='content'>

            {/* <div className="content-menu">
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/settings/permission" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(242, 123, 129)" }}>
                        <div className="shot-name">U</div>
                        <div className="full-name">Setting permission</div>
                        <div className="line"></div>
                        <div className="note">for manage permission</div>
                    </div>
                </div>
            </div> */}

            <div className="content-menu">
                <div className="box-menu" onClick={ () => history.push({ pathname: "/d-rec-admin/main/settings/user" }) }>
                    <div className="content" style={{ backgroundColor: "rgb(242, 123, 129)" }}>
                        <div className="shot-name">U</div>
                        <div className="full-name">Setting User</div>
                        <div className="line"></div>
                        <div className="note">for manage user</div>
                    </div>
                </div>
            </div>

        </div >);
}

export default Settings;